import { RouteRecordRaw } from 'vue-router'
import { moduleRoutes as usersRoutes } from '@/modules/users'
import { moduleRoutes as influencerRoutes } from '@/modules/influencers'
import { moduleRoutes as dashboardRoutes } from '@/modules/dashboard'
import { moduleRoutes as socialmediaRoutes } from '@/modules/socialmedia'
import { moduleRoutes as interestsRoutes } from '@/modules/interests'
import { moduleRoutes as businessSectorRoutes } from '@/modules/business-sector'
import { moduleRoutes as businessRoutes } from '@/modules/business'
import { moduleRoutes as promotionsRoutes } from '@/modules/promotions'
import { moduleRoutes as reportsRoutes } from '@/modules/reports'
import { moduleRoutes as salesRoutes } from '@/modules/sales'
import { moduleRoutes as collaborationsRoutes } from '@/modules/collaborations'
import { errorRoutes } from './ErrorRoutes'

const DashboardLayout = () =>
  import(
    /* webpackChunkName: "dashboard-layout" */ '@/core/layouts/DashboardLayout.vue'
  )

export const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    redirect: { name: 'dashboard' },
    component: DashboardLayout,
    meta: {
      auth: true,
    },
    children: [
      ...dashboardRoutes,
      ...usersRoutes,
      ...influencerRoutes,
      ...socialmediaRoutes,
      ...interestsRoutes,
      ...businessSectorRoutes,
      ...businessRoutes,
      ...promotionsRoutes,
      ...reportsRoutes,
      ...salesRoutes,
      ...collaborationsRoutes,
      ...errorRoutes,
    ],
  },
]
